<section class="treasury">
  <div class="treasury__card">
    <p class="treasury__step">Step 1 of 2</p>
    <h1 class="treasury__title">Load latest Treasury rates</h1>
    <p class="treasury__lead">
      Every Actuary and Finance report is priced off the latest US Treasury yield curve.
      Fetch today's rates here first — then continue to the reports.
    </p>

    @if (treasury.isLoadedToday()) {
      <div class="treasury__state treasury__state--ok" role="status">
        <i class="pi pi-check-circle" aria-hidden="true"></i>
        <div>
          <p class="treasury__state-title">Treasury rates are loaded for today.</p>
          <p class="treasury__state-text">You're all set — continue to the reports, or re-fetch if you need the very latest.</p>
        </div>
      </div>

      <div class="treasury__actions">
        <button type="button" class="btn btn--primary" (click)="continue()">
          Continue to reports <i class="pi pi-arrow-right" aria-hidden="true"></i>
        </button>
        <button type="button" class="btn btn--ghost" [disabled]="loading" (click)="fetchRates()">
          @if (loading) {
            <i class="pi pi-spin pi-spinner" aria-hidden="true"></i> Re-fetching…
          } @else {
            <i class="pi pi-refresh" aria-hidden="true"></i> Re-fetch rates
          }
        </button>
      </div>
    } @else {
      <div class="treasury__state treasury__state--todo" role="status">
        <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
        <div>
          <p class="treasury__state-title">Rates haven't been loaded yet today.</p>
          <p class="treasury__state-text">Load them before running any Actuary or Finance report.</p>
        </div>
      </div>

      <div class="treasury__actions">
        <button type="button" class="btn btn--primary" [disabled]="loading" (click)="fetchRates()">
          @if (loading) {
            <i class="pi pi-spin pi-spinner" aria-hidden="true"></i> Fetching latest rates…
          } @else {
            <i class="pi pi-download" aria-hidden="true"></i> Fetch latest Treasury rates
          }
        </button>
      </div>
    }

    @if (error) {
      <p class="treasury__error" role="alert">
        <i class="pi pi-times-circle" aria-hidden="true"></i> {{ error }}
      </p>
    }
  </div>
</section>
